import React, { lazy } from 'react';
import ContactForm from '../components/ContactForm';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
const ContactUs = () => {
  return <div className="w-full" data-id="element-247">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-248">
        <div className="container mx-auto px-4" data-id="element-249">
          <div className="text-center" data-id="element-250">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-251">Contact Us</h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-252">
              We're here to help with all your appliance repair needs
            </p>
          </div>
        </div>
      </section>
      {/* Contact Information and Form */}
      <section className="py-16" data-id="element-253">
        <div className="container mx-auto px-4" data-id="element-254">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-255">
            <div data-id="element-256">
              <h2 className="text-3xl font-bold text-[#1A5F7A] mb-6" data-id="element-257">
                Your Trusted Appliance Repair Experts
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-258">
                Welcome to Realmpoint, your trusted choice for fast and reliable
                appliance repairs across the UK. Our expert engineers specialise
                in servicing essential household appliances. We're committed to
                delivering high-quality repairs, transparent pricing, and
                outstanding customer service.
              </p>
              <p className="text-lg text-gray-600 mb-8" data-id="element-259">
                Whether you need an urgent repair, routine maintenance, or a
                customised service plan, Realmpoint has you covered. We
                understand how crucial your appliances are to your daily life,
                so we prioritise prompt responses, clear communication, and
                dependable support at every stage.
              </p>
              <p className="text-lg text-gray-600 mb-12" data-id="element-260">
                If you have questions, need advice, or want help selecting the
                right service plan, please get in touch. We're here to keep your
                appliances running smoothly—so you can relax knowing your home
                is in expert hands.
              </p>
              <div className="space-y-6" data-id="element-261">
                <div className="flex items-start" data-id="element-262">
                  <div className="flex-shrink-0 mt-1" data-id="element-263">
                    <MapPinIcon className="w-6 h-6 text-[#159895]" data-id="element-264" />
                  </div>
                  <div className="ml-4" data-id="element-265">
                    <h3 className="text-lg font-bold text-[#1A5F7A]" data-id="element-266">
                      Address
                    </h3>
                    <p className="text-gray-600" data-id="element-267">
                      19 Clayton St, Newcastle upon Tyne NE1 5PY
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-268">
                  <div className="flex-shrink-0 mt-1" data-id="element-269">
                    <PhoneIcon className="w-6 h-6 text-[#159895]" data-id="element-270" />
                  </div>
                  <div className="ml-4" data-id="element-271">
                    <h3 className="text-lg font-bold text-[#1A5F7A]" data-id="element-272">Phone</h3>
                    <p className="text-gray-600" data-id="element-273">0800 055 4969</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-274">
                  <div className="flex-shrink-0 mt-1" data-id="element-275">
                    <MailIcon className="w-6 h-6 text-[#159895]" data-id="element-276" />
                  </div>
                  <div className="ml-4" data-id="element-277">
                    <h3 className="text-lg font-bold text-[#1A5F7A]" data-id="element-278">Email</h3>
                    <p className="text-gray-600" data-id="element-279">bijayathakur8098@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-280">
                  <div className="flex-shrink-0 mt-1" data-id="element-281">
                    <ClockIcon className="w-6 h-6 text-[#159895]" data-id="element-282" />
                  </div>
                  <div className="ml-4" data-id="element-283">
                    <h3 className="text-lg font-bold text-[#1A5F7A]" data-id="element-284">
                      Opening Hours
                    </h3>
                    <p className="text-gray-600" data-id="element-285">
                      Monday to Friday: 9:00am – 5:00pm
                    </p>
                    <p className="text-gray-600" data-id="element-286">Saturday & Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative" data-id="element-287">
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')] bg-cover bg-center opacity-20 rounded-lg" data-id="element-288"></div>
              <div className="relative z-10" data-id="element-289">
                <h2 className="text-2xl font-bold text-[#1A5F7A] mb-6" data-id="element-290">
                  Send Us a Message
                </h2>
                <ContactForm data-id="element-291" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Map Section */}
      <section className="py-16 bg-[#f0f9ff]" data-id="element-292">
        <div className="container mx-auto px-4" data-id="element-293">
          <div className="text-center mb-12" data-id="element-294">
            <h2 className="text-3xl font-bold text-[#1A5F7A]" data-id="element-295">Find Us</h2>
            <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-296">
              Visit our office in Newcastle upon Tyne or contact us for a
              service call to your location
            </p>
          </div>
          <div className="h-[400px] rounded-lg overflow-hidden shadow-lg" data-id="element-297">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2289.901033029422!2d-1.6159126839604316!3d54.97399798035383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487e70c0d3eb2f7f%3A0x1d5c7c3c9a1b7b8a!2s19%20Clayton%20St%2C%20Newcastle%20upon%20Tyne%20NE1%205PY%2C%20UK!5e0!3m2!1sen!2sus!4v1651234567890!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Realmpoint location" data-id="element-298"></iframe>
          </div>
        </div>
      </section>
    </div>;
};
export default ContactUs;